import type { HashCache } from "../types";
import type { EidsUserSource } from "@omni/ads";

import { UseLocalStorage } from "../../../hooks/useLocalStorage/useLocalStorage";
import { getPulseTracker } from "../../../pulse";
import { fetchPPID3Hashes } from "..";

const LOCAL_STORAGE_KEY = "hasher_ppid3";

const PPID3CacheHandler = async (
  userIdFromSPiD?: string,
  isEconomy?: boolean,
): Promise<EidsUserSource[]> => {
  const pulse = getPulseTracker();
  const useLocalStorage = UseLocalStorage();
  const PPPID3Eids: EidsUserSource[] = [];

  try {
    const pulseEnvId = await pulse?.pulseTracker.getEnvironmentId();

    const environmentId =
      pulseEnvId && !userIdFromSPiD
        ? `sdrn:schibsted:environment:${pulseEnvId}`
        : undefined;
    const userId = userIdFromSPiD
      ? `sdrn:schibsted.com:user:${userIdFromSPiD}`
      : undefined;
    const clientId = isEconomy ? "omniekonomi" : "omni";
    const trackerType = "Custom";
    const trackerVersion = "1.0.0";
    const hashedValue = useLocalStorage.get(
      LOCAL_STORAGE_KEY,
    ) as HashCache | null;

    if (
      (environmentId &&
        hashedValue &&
        hashedValue.environmentId.plain === environmentId) ||
      (userId && hashedValue && hashedValue.userId.plain === userId)
    ) {
      if (userId && hashedValue.userId.hashed) {
        PPPID3Eids.push({
          id: hashedValue.userId.hashed,
          source: "schse-userhash-v3",
        });
      }
      if (environmentId && hashedValue.environmentId.hashed) {
        PPPID3Eids.push({
          id: hashedValue.environmentId.hashed,
          source: "schse-envhash-v3",
        });
      }
    } else {
      const data = await fetchPPID3Hashes({
        clientId,
        userId,
        environmentId,
        trackerType,
        trackerVersion,
      });

      const hashCache: HashCache = {
        userId: {
          plain: userId || null,
          hashed: data?.userId,
        },
        environmentId: {
          plain: environmentId || null,
          hashed: data?.environmentId,
        },
        clientId,
        trackerType,
        trackerVersion,
      };
      useLocalStorage.set(LOCAL_STORAGE_KEY, hashCache);

      if (userId && data?.userId) {
        PPPID3Eids.push({
          id: data.userId,
          source: "schse-userhash-v3",
        });
      }
      if (environmentId && data?.environmentId) {
        PPPID3Eids.push({
          id: data.environmentId,
          source: "schse-envhash-v3",
        });
      }
    }
  } catch (e) {
    console.error(e);
  }

  return PPPID3Eids;
};

export { PPID3CacheHandler };
